import CustomizationView from './CustomizationView'

export default CustomizationView